import { render, staticRenderFns } from "./unmatched-shops-list.vue?vue&type=template&id=793ac78c&scoped=true"
import script from "./unmatched-shops-list.vue?vue&type=script&lang=js"
export * from "./unmatched-shops-list.vue?vue&type=script&lang=js"
import style0 from "./unmatched-shops-list.vue?vue&type=style&index=0&id=793ac78c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793ac78c",
  null
  
)

export default component.exports